import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/styles";
import CountrySearch from "./countySearch";
import CurrencySearch from "./currencySearch";
import LanguageSearch from "./languageSearch";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles({
  span: {
    background: "#f8f8f8",
    textAlign: "center",
    padding: "5px 0",
    fontSize: "13px",
    color: "#999",
    display: "block",
    margin: "0 1px"
  }
});

export default function SelectCountry(props) {
  const [country, setCountry] = useState(undefined);
  const [currency, setCurrency] = useState(undefined);
  const [language, setLanguage] = useState(undefined);
  const { multiLang, lang } = props;
  const classes = useStyles();

  return (
    <div>
      <Grid container>
        <Grid item xs={12} style={{ marginBottom: "10px" }}>
          <span className={classes.span}>{multiLang["A025"][lang]}</span>
          <CountrySearch getvalue={e => setCountry(e)} />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: "10px" }}>
          <span className={classes.span}>{multiLang["A026"][lang]}</span>
          <CurrencySearch getvalue={e => setCurrency(e)} />
        </Grid>
        <Grid item xs={12} style={{ marginBottom: "10px" }}>
          <span className={classes.span}>{multiLang["A027"][lang]}</span>
          <LanguageSearch getvalue={e => setLanguage(e)} />
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          console.log(country, currency, language);
          props.setLang(language);
        }}
        style={{ display: "block", margin: "0 auto 10px" }}
      >
        {multiLang["A028"][lang]}
      </Button>
    </div>
  );
}
